import type { StateType } from '../../lib/types/state-type';
import type { FurnhomeCommunication } from '@dh-software/furnhome-communication';

export function login(state: StateType, communication: FurnhomeCommunication): StateType {
  window.location.href = communication.getLoginUrl(window.location.href);
  return { ...state, page: 'login' };
}
